/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { SddcDetailsResponse } from '../model/sddcDetailsResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class SddcOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Manage SDDCs
     * Retrieve all SDDCs
     * @param orgId organization identifier in optional filter
     * @param sddcId SDDC identifier in optional filter
     * @param resourcePoolProviderType Resource pool provider type
     * @param sddcState SDDC state in optional filter
     * @param providerId Resource Provider identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSDDCsOperator(orgId?: string, sddcId?: string, resourcePoolProviderType?: 'GCVE' | 'VMCA' | 'EVS', sddcState?: 'READY' | 'ACTIVE' | 'DEPLOYING' | 'CREATING' | 'DELETED' | 'DELETING' | 'UPDATING' | 'FAILED' | 'CANCELLED', providerId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<SddcDetailsResponse>>;
    public getSDDCsOperator(orgId?: string, sddcId?: string, resourcePoolProviderType?: 'GCVE' | 'VMCA' | 'EVS', sddcState?: 'READY' | 'ACTIVE' | 'DEPLOYING' | 'CREATING' | 'DELETED' | 'DELETING' | 'UPDATING' | 'FAILED' | 'CANCELLED', providerId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<SddcDetailsResponse>>>;
    public getSDDCsOperator(orgId?: string, sddcId?: string, resourcePoolProviderType?: 'GCVE' | 'VMCA' | 'EVS', sddcState?: 'READY' | 'ACTIVE' | 'DEPLOYING' | 'CREATING' | 'DELETED' | 'DELETING' | 'UPDATING' | 'FAILED' | 'CANCELLED', providerId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<SddcDetailsResponse>>>;
    public getSDDCsOperator(orgId?: string, sddcId?: string, resourcePoolProviderType?: 'GCVE' | 'VMCA' | 'EVS', sddcState?: 'READY' | 'ACTIVE' | 'DEPLOYING' | 'CREATING' | 'DELETED' | 'DELETING' | 'UPDATING' | 'FAILED' | 'CANCELLED', providerId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sddcId, 'sddc-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourcePoolProviderType, 'resource-pool-provider-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sddcState, 'sddc-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>providerId, 'provider-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/sddc`;
        return this.httpClient.request<Array<SddcDetailsResponse>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
